module.exports = __webpack_public_path__ + "img/header.2ee14dfe.jpg";